import styled from '@emotion/styled';
import { theme } from '~/theme';
import { breakpoints } from '~/theme/breakpoints';

type simpleProductProps = {
    isMiniBasket?: boolean;
};

export const StyledSimpleProductInfoBrand = styled.span<simpleProductProps>(({ isMiniBasket }) => ({
    display: 'block',
    color: theme.colors.black,
    fontSize: theme.fontSizes['exs'],
    lineHeight: theme.fontSizes['xs'],
    fontWeight: theme.fontWeights.medium,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '80px',
    [breakpoints.md]: {
        fontSize: theme.fontSizes['2xs'],
        width: '110px',
        ...(!isMiniBasket && {
            width: '95%',
            whiteSpace: 'unset',
            overflow: 'unset',
            textOverflow: 'unset',
        }),
    },
    [breakpoints.lg]: {
        fontSize: theme.fontSizes['xs'],
    },
}));

export const StyledSimpleProductInfoTitle = styled.p<simpleProductProps>(({ isMiniBasket }) => ({
    color: theme.colors.black,
    fontSize: theme.fontSizes['2xs'],
    lineHeight: theme.lineHeights.base,
    fontWeight: theme.fontWeights.medium,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '80px',
    [breakpoints.md]: {
        fontSize: theme.fontSizes['sm'],
        width: '110px',
        ...(!isMiniBasket && {
            width: '95%',
            whiteSpace: 'unset',
            overflow: 'unset',
            textOverflow: 'unset',
        }),
    },
    [breakpoints.lg]: {
        fontSize: theme.fontSizes['md'],
    },
}));

export const StyledSimpleProductInfoMaterial = styled.div<simpleProductProps>(
    ({ isMiniBasket }) => ({
        color: theme.colors.black,
        fontSize: theme.fontSizes['exs'],
        lineHeight: theme.lineHeights.base,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '80px',
        [breakpoints.md]: {
            fontSize: theme.fontSizes['2xs'],
            width: '110px',
            ...(!isMiniBasket && {
                width: '95%',
                whiteSpace: 'unset',
                overflow: 'unset',
                textOverflow: 'unset',
            }),
        },
        [breakpoints.lg]: {
            fontSize: theme.fontSizes['xs'],
            marginBottom: '10px',
        },
    })
);
